import React, { useState } from "react";

type TooltipProps = {
  content?: React.ReactNode;
  children: React.ReactNode;
};

export default function FloatingTooltip({ content, children }: TooltipProps) {
  const [isVisible, setIsVisible] = useState(false);

  return (
    <div
      className="relative flex items-center"
      onMouseEnter={() => setIsVisible(true)}
      onMouseLeave={() => setIsVisible(false)}
    >
      {children}
      {isVisible && content && (
        <div className="absolute bottom-full left-1/2 transform -translate-x-1/2 mb-2 w-max max-w-xs bg-blue-strong text-white text-xs py-1 px-2 rounded shadow-lg">
          {content}
          <div className="absolute top-full left-1/2 transform -translate-x-1/2 h-0 w-0 border-x-[6px] border-x-transparent border-t-[6px] border-t-blue-strong"></div>
        </div>
      )}
    </div>
  );
}
